// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".show-edit-mode-btn[data-v-ef794ac4]{position:fixed;bottom:65px;right:10px;z-index:1;display:flex;flex-direction:column;grid-gap:1rem;gap:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
